module.exports = __webpack_public_path__ + "static/media/agc021.3fc10aa3.jpg";